import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const PaiementVirementCotisation = (props) => {



    return (
        <Modal show={props.cotisation} onHide={() => props.setChangement()}>
            <Modal.Header closeButton>
                <Modal.Title>Paiement par virement bancaire</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formReference">
                        <Form.Label>Nom du bénéficiaire</Form.Label>
                        <Form.Control type="text" value={props.cotisation.coach[0].nom + ' ' + props.cotisation.coach[0].prenom} disabled placeholder="Nom du bénéficiaire" />
                    </Form.Group>
                    <Form.Group controlId="formMontant">
                        <Form.Label>Montant à payer</Form.Label>
                        <Form.Control type="number" value={props.cotisation.cotisationJoueur[0].prixCotisation} disabled placeholder="Montant en euros" />
                    </Form.Group>
                    <Form.Group controlId="formReference">
                        <Form.Label>Compte en banque</Form.Label>
                        <Form.Control type="text" value={props.cotisation.cotisationJoueur[0].compteBancaire} disabled placeholder="Compte en banque" />
                    </Form.Group>
                    <Form.Group controlId="formReference">
                        <Form.Label>Commentaire du virement</Form.Label>
                        <Form.Control type="text" placeholder="Référence de paiement"  disabled value={'***'+props.cotisation.cotisationJoueur[0].nom + '-' + props.cotisation.cotisationJoueur[0].prenom + '***' }/>
                    </Form.Group>
                    <p>
                        Une fois que le virement est effectué, veuillez cliquer sur le bouton "Confirmer" pour finaliser le paiement.
                    </p>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => props.setChangement()}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={(e) => props.handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}} >
                    Confirmer le paiement
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PaiementVirementCotisation;
